module.exports = __webpack_public_path__ + "img/jifen_bg.bcb2e70c.webp";